import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserAuthFacade } from '@state/user-auth';
import { MODAL_MESSAGE, ModalOpts } from './intro-modal.service';

@Component({
  selector: 'app-intro-modal',
  templateUrl: './intro-modal.component.html',
  styleUrls: ['./intro-modal.component.scss'],
})
export class IntroModalComponent {
  public additionalMessage = '';

  public MODAL_MESSAGE = MODAL_MESSAGE;

  public branding$ = this.userAuthFacade.branding$;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalOpts,
    public dialogRef: MatDialogRef<IntroModalComponent>,
    private readonly userAuthFacade: UserAuthFacade
  ) {}

  public close(returnVal?: any): void {
    this.dialogRef.close(returnVal);
  }
}
